(ns practitest.frontend.components2.dashboard.charts.pie
  (:require [practitest.frontend.components2.dashboard.charts.render :as r]
            [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [practitest.frontend.components2.dashboard.charts.protocol :as p]
            [practitest.frontend.components2.dashboard.charts.render-helpers :as rh]
            [practitest.frontend.components2.dashboard.charts.arc-labels :as arc-labels]
            [practitest.frontend.components2.dashboard.transforms.pie :as transforms]
            [practitest.frontend.components2.dashboard.events :as-alias events]
            [re-frame.core :as rf]))

(defn base-spec [chart]
  (let [palette         (:chart/colors-palette chart)
        category-labels (:chart/legend-labels chart)
        ordered-range   (mapv (fn [label] (get palette label)) category-labels)]
    {:mark              :arc
     :padding           {:top 20 :right 20 :left 20 :bottom 20}
     :max-radius        105
     :data              (:chart/data chart)
     :tooltip           true
     :encode            {:theta   {:field :value :type :quantitative}
                         :tooltip {:mode :category-value}
                         :color   {:field :category
                                   :type  :nominal
                                   :scale {:domain category-labels
                                           :range  ordered-range}}}}))

(defmethod p/render! ::chart/pie [chart _ctx svg-element]
  (let [nav-evt #(rf/dispatch [::events/navigate chart %])
        spec    (cond-> (base-spec chart)
                  (:chart/item-route chart)
                  (assoc :on-bar-click nav-evt))]
    (r/render-chart! svg-element spec)))

(defmethod p/transform-data ::chart/pie [chart]
  (transforms/transform chart))

(defmethod p/svg-for-export ::chart/pie [_chart svg-element]
  (let [clone (rh/clone-svg svg-element)]
    (arc-labels/prepare-export! svg-element clone)
    (rh/embed-styles! svg-element clone [".connector"])
    clone))
